export const getTodayAt = (number) => { 
    const date = new Date();

    date.setHours(number);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setUTCMilliseconds(0);

    return date;
}